<template>
    <tr class="p-grid">
        <td  class="p-col">
        </td>
        <th v-for="day in days" :class="`${addClass} p-col`">
            <h2>
                {{ day.display }}
            </h2>
        </th>
    </tr>
</template>

<script>
import {days} from "@/views/Schedule/Schedule";

export default {
    name: "Header",
    props: {
        addClass: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            days
        }
    },
}
</script>

<style scoped>
th.grade{
    text-align: center !important;
    background: #6ace54;
    color: #fff;

}

th.teacher{
    text-align: center !important;
    background: #2dc7a8;
    color: #fff;

}
</style>